<template>
  <rd-container size="large" type="basic">
    <rd-header :title="$t(`index.title`)" />

    <Panel :title="$t('index.packagesVersions')">
      <template v-slot:content>
        <PackagesVersions />
      </template>
    </Panel>

    <Panel :title="$t('index.databaseUsage')">
      <template v-slot:content>
        <DatabaseUsage />
      </template>
    </Panel>
  </rd-container>
</template>
<script>

// i18n
import localMessages from "../locales";

// components
import DatabaseUsage from "../components/DatabaseUsage";
import Panel from "../components/Panel.vue";
import PackagesVersions from "../components/PackagesVersions";

export default {
  name: "SystemInformation",
  components: {
    DatabaseUsage,
    Panel,
    PackagesVersions,
  },
  i18n: {
    messages: localMessages.messages,
  },
};
</script>
